import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import clearFilePickerBreadcrumb from '../clearFilePickerBreadcrumb';
import FilePickerViewState from '../../store/schema/FilePickerViewState';
import pushFilePickerBreadcrumb from '../pushFilePickerBreadcrumb';
import { action } from 'satcheljs/lib/legacy';
import { createBreadcrumbForFileProvider } from '../changeSelectedFileProvider';
import { FilePickerBreadcrumb } from '../../store/schema/FilePickerViewState';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { ScopeBreadcrumbId } from '../../utils/filePickerConstants';

function createSearchBreadcrumbFromScope(scope?: AttachmentDataProviderScope) {
    return <FilePickerBreadcrumb>{
        id: ScopeBreadcrumbId,
        name: `${scope.DisplayName} ...`,
        associatedItem: null,
    };
}

export default action('setBreadcrumbsForSearch')(function setBreadcrumbsForSearch(
    fileProvider: FileProviderViewState,
    scope: AttachmentDataProviderScope,
    viewState: FilePickerViewState
) {
    if (!fileProvider) {
        throw new Error(
            'Filepicker - should not create search breadcrumbs without a file provider'
        );
    }

    // Clear the breadcrumbs
    clearFilePickerBreadcrumb(viewState);

    // Push a breadcrumb for the file provider
    pushFilePickerBreadcrumb(createBreadcrumbForFileProvider(fileProvider), viewState);

    // push a search version of the breadcrumb for the scope.
    pushFilePickerBreadcrumb(createSearchBreadcrumbFromScope(scope), viewState);
});
